@if (showMainSummarySection()) {
  <app-order-modal-summary-main-section
    [order]="order()"
    [mode]="mode()"
    [close$]="close$()"
  ></app-order-modal-summary-main-section>
} @else if (!isInactive() && OrderHelper.isFinished(order())) {
  <app-order-modal-finished-section
    [order]="order()"
    [close$]="close$()"
  ></app-order-modal-finished-section>
}

@if (missingAssignment() && order().relatedFleetSwap; as relatedFleetSwap) {
  <app-order-modal-planned-swap-point
    [order]="order()"
    [relatedFleetSwap]="relatedFleetSwap"
  ></app-order-modal-planned-swap-point>
}

@if (
  (missingAssignment() || OrderHelper.hasApprovedVehicle(order())) &&
    !OrderHelper.isFinished(order()) &&
    currentPoint();
  as currentPoint
) {
  <app-order-modal-realization
    [order]="order()"
    [currentPoint]="currentPoint"
  ></app-order-modal-realization>
}

@if (OrderHelper.isCanceled(order()) && order().cancellation; as cancellation) {
  <app-order-modal-cancellation
    [cancellation]="cancellation"
  ></app-order-modal-cancellation>
}

<app-order-modal-route-summary
  [order]="order()"
  [close$]="close$()"
></app-order-modal-route-summary>

@if (
  OrderHelper.hasApprovedVehicle(order()) && !OrderHelper.isFinished(order())
) {
  <app-order-modal-assignment
    [order]="order()"
    [close$]="close$()"
  ></app-order-modal-assignment>
} @else if (OrderHelper.isFinished(order())) {
  @if (order().outsourcingData) {
    <app-order-modal-outsourcing-data
      [order]="order()"
      [close$]="close$()"
    ></app-order-modal-outsourcing-data>
  } @else if (order().assignedData?.vehicle) {
    <app-modal-realized-by [order]="order()"></app-modal-realized-by>
  }
}

<app-order-modal-plan [order]="order()"></app-order-modal-plan>

<app-order-modal-goods [order]="order()"></app-order-modal-goods>
